import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import Sidebar, { SIDEBAR_WIDTH } from "./Sidebar";
import TopBar from "./TopBar";
import FloatingIcons from "@/components/common/FloatingIcons";

export default function DashboardLayout() {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex min-h-screen">
      <Sidebar
        open={isMobile ? mobileOpen : true}
        onClose={() => setMobileOpen(false)}
        variant={isMobile ? "temporary" : "permanent"}
      />

      <TopBar
        onMenuClick={() => setMobileOpen(true)}
        isMobile={isMobile}
      />

      <main
        className="flex-1 min-h-screen bg-background relative"
        style={{
          marginLeft: isMobile ? 0 : SIDEBAR_WIDTH,
          width: isMobile ? "100%" : `calc(100% - ${SIDEBAR_WIDTH}px)`,
        }}
      >
        <FloatingIcons count={24} />
        {/* Spacer for fixed topbar */}
        <div className="h-16" />
        <div className="relative z-10 px-4 py-4 sm:px-6 sm:py-5 max-w-[1600px] mx-auto w-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
